var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.041,
    viewBox: "0 0 16 14.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5967",
    "data-name": "Group 5967",
    transform: "translate(-13482.987 -22415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5945",
    "data-name": "Path 5945",
    d: "M132.309,84.49a.385.385,0,0,0,.372-.372v-.9h1.782a1.4,1.4,0,0,0,1.39-1.391v-1.1a2.039,2.039,0,0,0,1.665-2,2.017,2.017,0,1,0-2.389,2v1.1a.652.652,0,0,1-.646.646H132.7V81.4a.385.385,0,0,0-.372-.372h-5.64a.385.385,0,0,0-.372.372v1.057h-1.782a1.4,1.4,0,0,0-1.39,1.39v1.018a2.026,2.026,0,1,0,2.409,2,2.038,2.038,0,0,0-1.684-2v-1a.652.652,0,0,1,.646-.646H126.3v.92a.385.385,0,0,0,.372.372h2.448v3.408a1.4,1.4,0,0,0,1.391,1.39h.509a1.743,1.743,0,0,0,1.7,1.449h2.193a1.743,1.743,0,0,0,0-3.486H132.76a1.745,1.745,0,0,0-1.684,1.293h-.548a.652.652,0,0,1-.646-.646V84.49Zm1.9-5.758a1.293,1.293,0,1,1,1.293,1.293A1.291,1.291,0,0,1,134.209,78.732Zm-9.4,8.127a1.293,1.293,0,1,1-1.293-1.293A1.291,1.291,0,0,1,124.809,86.859ZM132.76,88h2.193a1,1,0,0,1,0,2H132.76a1,1,0,0,1,0-2Zm-5.7-6.247h4.876v2h-4.876Z",
    transform: "translate(13361.469 22338.285)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecision);
export default __webpack_public_path__ + "static/media/decision.9f718735690f8c1167d697c529e55ae3.svg";
export { ForwardRef as ReactComponent };